/** Player-site navigation for the UT shell. */

export interface UtNavItem {
  key: string;
  label: string;
  to: string;
  /** True when the current location belongs to this item. */
  match: (pathname: string, search: string) => boolean;
}

/** Signed-in only (signed out, "/" is the table): the header filters it. */
export const HOME_NAV: UtNavItem = { key: 'home', label: 'Home', to: '/', match: (p) => p === '/' };
const game: UtNavItem = { key: 'game', label: 'Game', to: '/games', match: (p) => p.startsWith('/games') };
const results: UtNavItem = { key: 'results', label: 'Results', to: '/results', match: (p) => p.startsWith('/results') };
const players: UtNavItem = {
  key: 'players',
  label: 'Players',
  to: '/players',
  match: (p) => p.startsWith('/players') || p.startsWith('/player/'),
};
const ratings: UtNavItem = { key: 'ratings', label: 'Ratings', to: '/ratings', match: (p) => p.startsWith('/ratings') };

/** Mobile bottom tabs: Table covers the leaderboard page and Trophies (reached from its Awards tab). */
export const UT_TABS: UtNavItem[] = [
  game,
  { key: 'table', label: 'Table', to: '/leaderboards', match: (p) => p.startsWith('/leaderboards') || p.startsWith('/trophies') },
  results,
  players,
  ratings,
];

/** Tablet/desktop top nav: Trophies gets its own entry. */
export const UT_TOP_NAV: UtNavItem[] = [
  HOME_NAV,
  game,
  { key: 'table', label: 'Table', to: '/leaderboards', match: (p) => p.startsWith('/leaderboards') },
  { key: 'trophies', label: 'Trophies', to: '/trophies', match: (p) => p.startsWith('/trophies') },
  results,
  players,
  ratings,
];
